import cls from "@fvilers/cls";
import { CloseIcon } from "@imi/icons/CloseIcon.js";
import { ComponentPropsWithRef } from "react";
import { TouchTarget } from "../TouchTarget/TouchTarget";
import styles from "./Dialog.module.css";
import { DialogClose } from "./DialogClose";

export function DialogCloseButton({
  children,
  className,
  ...props
}: ComponentPropsWithRef<"button">) {
  return (
    <DialogClose asChild>
      <button className={cls(styles.DialogCloseButton, className)} {...props}>
        <TouchTarget>
          <CloseIcon />
          {children}
        </TouchTarget>
      </button>
    </DialogClose>
  );
}
